import * as React from 'react';
import { Box, Stack, Typography } from '@mui/material';

interface FormSectionProps {
  title: string;
  description?: React.ReactNode;
  /** Element po prawej stronie naglowka, np. przelacznik wlaczajacy sekcje. */
  action?: React.ReactNode;
  children?: React.ReactNode;
}

/**
 * Karta z naglowkiem grupujaca powiazane pola dlugiego formularza. Bez dzieci zostaje
 * sam naglowek - np. gdy sekcja jest wylaczona przelacznikiem z `action`.
 */
export const FormSection: React.FC<FormSectionProps> = ({
  title,
  description,
  action,
  children,
}) => (
  <Box
    component="section"
    sx={{
      p: { xs: 'var(--space-4)', md: 'var(--space-6)' },
      border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius-md)',
      backgroundColor: 'var(--color-surface)',
    }}
  >
    <Stack direction="row" alignItems="flex-start" sx={{ gap: 'var(--space-3)' }}>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography component="h2" sx={{ fontWeight: 700, fontSize: 'var(--text-base)' }}>
          {title}
        </Typography>
        {description && (
          <Typography sx={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-secondary)' }}>
            {description}
          </Typography>
        )}
      </Box>
      {action}
    </Stack>
    {children && <Box sx={{ mt: 'var(--space-4)' }}>{children}</Box>}
  </Box>
);
